// hooks.ts
import { useEffect, useState } from "react";
import {
  calculateAmount,
  createNestedMap,
  createPaymentModeItem,
  epmrValidationMessages,
  filterKeysByValue,
  getSelectedItemList,
  handleStripMessages,
  isFailedChequeHistory,
  isPopupMessageExist,
  isUpFrontOrEpmrEnabled,
  getNetItemsBalance,
  epmrDetails,
  isSeatBookingEnabled,
  isEnachEnabled,
  isChequeEnabled,
} from "../../utils";
import {
  fetchPosFlagService,
  getFeeConfiguration,
  getStudentDetails,
} from "../../apis";

export const useChargesUpdater = (
  selectedIndexMapCharges,
  setSelectedChargesAmount,
  setSelectedCharges,
  studentChargesList,
  studentBasicDetails,
  setPartialPaymentAmount,
) => {
  useEffect(() => {
    const updateCharges = () => {
      const selectedRegularChargesMap = selectedIndexMapCharges.REGULAR_CHARGES;
      const selectedOtherChargesMap = selectedIndexMapCharges.OTHER_CHARGES;
      const epmrPaymentDetails = epmrDetails(studentBasicDetails);

      const REGULAR_CHARGES = createNestedMap(
        filterKeysByValue(selectedRegularChargesMap),
      );
      const OTHER_CHARGES = createNestedMap(
        filterKeysByValue(selectedOtherChargesMap),
      );

      const { totalAmount, selectedItems } = calculateAmount(
        REGULAR_CHARGES,
        studentChargesList["REGULAR_CHARGES"],
      );
      const otherChargesResult = calculateAmount(
        OTHER_CHARGES,
        studentChargesList["OTHER_CHARGES"],
      );
      if (studentBasicDetails?.upFrontAmount && totalAmount) {
        setSelectedChargesAmount(studentBasicDetails?.upFrontAmount);
      } else if (epmrPaymentDetails) {
        setSelectedChargesAmount(epmrPaymentDetails.paidAmount);
      } else {
        setSelectedChargesAmount(totalAmount + otherChargesResult.totalAmount);
      }
      setSelectedCharges((prev) => ({
        ...prev,
        REGULAR_CHARGES: selectedItems,
        OTHER_CHARGES: otherChargesResult.selectedItems,
      }));
    };

    updateCharges();
    setPartialPaymentAmount(0);
  }, [selectedIndexMapCharges, studentBasicDetails]);
};
const filterImpl = (charge, appliedFilter) => {
  if (appliedFilter === "UNPAID") {
    return ["UNPAID", "PARTIALLY_PAID"].includes(charge.status);
  } else {
    return charge.status?.toLowerCase() === appliedFilter?.toLowerCase();
  }
};
export const useChargesFilter = (
  selectedFilter,
  studentChargesList,
  setStudentChargesListFiltered,
) => {
  useEffect(() => {
    const filterCharges = () => {
      const filterByStatus = (charges) => {
        if (selectedFilter !== "all") {
          return charges.filter((charge) => filterImpl(charge, selectedFilter));
        }
        return charges;
      };

      const filteredRegularCharges = filterByStatus(
        studentChargesList.REGULAR_CHARGES || [],
      );
      const filteredOtherCharges = filterByStatus(
        studentChargesList.OTHER_CHARGES || [],
      );
      console.log(filteredOtherCharges);
      setStudentChargesListFiltered({
        REGULAR_CHARGES: filteredRegularCharges,
        OTHER_CHARGES: filteredOtherCharges,
      });
    };

    filterCharges();
  }, [selectedFilter, studentChargesList]);
};

export const useAutoSelectCharges = (
  studentBasicDetails,
  studentChargesList,
  setSelectedIndexMapCharges,
  setAlertPopup,
  setDisableItemSelection,
  setCollectPayment,
) => {
  useEffect(() => {
    const autoSelectCharges = (chargesList, key) => {
      if (chargesList?.length > 0) {
        const selectedChargesMap = {};
        (chargesList || []).forEach((charge, index) => {
          if (charge?.itemTypeWiseInstallmentsList?.length > 0) {
            charge.itemTypeWiseInstallmentsList.forEach((child, childIndex) => {
              selectedChargesMap[`${index}-${childIndex}`] =
                child?.isAutoSelect;
            });
          }
          selectedChargesMap[index] =
            charge?.isAutoSelect ||
            (charge?.itemTypeWiseInstallmentsList || []).some(
              (item) => item?.isAutoSelect,
            );
        });
        setSelectedIndexMapCharges((prev) => ({
          ...prev,
          [key]: selectedChargesMap,
        }));
      }
    };
    if (
      isSeatBookingEnabled(studentBasicDetails) ||
      isEnachEnabled(studentBasicDetails)
    ) {
      autoSelectCharges(
        studentChargesList["REGULAR_CHARGES"] || [],
        "REGULAR_CHARGES",
      );
    }
    if (isChequeEnabled(studentBasicDetails)) {
      autoSelectCharges(
        studentChargesList["REGULAR_CHARGES"] || [],
        "REGULAR_CHARGES",
      );
      autoSelectCharges(
        studentChargesList["OTHER_CHARGES"] || [],
        "OTHER_CHARGES",
      );
      setDisableItemSelection((prev) => ({ ...prev, isAutoSelect: true }));
    }
    if (isUpFrontOrEpmrEnabled(studentBasicDetails)) {
      autoSelectCharges(
        studentChargesList["REGULAR_CHARGES"] || [],
        "REGULAR_CHARGES",
      );

      autoSelectCharges(
        studentChargesList["OTHER_CHARGES"] || [],
        "OTHER_CHARGES",
      );

      if (isPopupMessageExist(studentBasicDetails) > 0) {
        setAlertPopup({
          isOpen: true,
          ...studentBasicDetails?.popUpMessageList[0],
        });
      }
      // in case of empr show message from UI side
      if (!isPopupMessageExist(studentBasicDetails)) {
        setAlertPopup(epmrValidationMessages());
        setCollectPayment([{ ...createPaymentModeItem(studentBasicDetails) }]);
      }

      setDisableItemSelection((prev) => ({ ...prev, isAutoSelect: true }));
    }
  }, [studentBasicDetails, studentChargesList]);
};

export const useFailedChequeCheck = (
  studentChargesList,
  studentBasicDetails,
  setTopStrip,
) => {
  useEffect(() => {
    const failedChequeMessageDetails = isFailedChequeHistory(
      studentChargesList,
      studentBasicDetails,
    );
    if (failedChequeMessageDetails?.length > 0) {
      handleStripMessages(failedChequeMessageDetails, setTopStrip);
    }
  }, [studentChargesList, studentBasicDetails]);
};

const activePosList = (list) => {
  return list.filter((item) => item?.status === "ACTIVE");
};
// current check for pine lab or paytm
const isFeatureActive = (businessAreaFeatureSetupList) => {
  const featureSetup = businessAreaFeatureSetupList
    .filter((item) => item?.status === "ACTIVE")
    .find((item) => {
      const feature = item.feature.toLowerCase();
      return (
        feature === "pinelabs".toLowerCase() ||
        feature === "paytm".toLowerCase()
      );
    });

  return featureSetup ? featureSetup.status.toLowerCase() === "active" : false;
};

export const useFetchPosFlag = (studentBasicDetails, setAvailablePos) => {
  const [isPosEnabled, setPosEnabled] = useState(false);
  useEffect(() => {
    const fetchPosFlag = async () => {
      const posFlag = await fetchPosFlagService(studentBasicDetails?.buId);
      if (posFlag?.businessAreaFeatureSetupList?.length === 0) {
        setPosEnabled(false);
      } else {
        const activePosMachines = activePosList(
          posFlag?.businessAreaFeatureSetupList,
        );

        setAvailablePos(activePosMachines);
        setPosEnabled(isFeatureActive(activePosMachines || []));
      }
    };
    if (studentBasicDetails?.buId) fetchPosFlag();
  }, [studentBasicDetails]);

  return isPosEnabled;
};

export const useGetFeeConfiguration = (academicCareer, studentBusinessArea) => {
  const [feeConfiguration, setFeeConfiguration] = useState({});
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

   const request = {
      companyCode: "AESL1",
      academicCareers: [academicCareer],
      businessAreas: ["ALL",studentBusinessArea],
      mode: "OFFLINE",
      status: "ACTIVE",
    };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await getFeeConfiguration(request);
        if (response?.code === 200) {

          const feeConfigsList =
            response?.data?.sdChargeSequencingMasterDtoList || [];
            // 
          const applicableFeeConfig =
            feeConfigsList?.find(
              (config) =>
                config?.businessArea === studentBusinessArea &&
                config?.academicCareer === academicCareer
                && config?.status === "ACTIVE") ||
            feeConfigsList?.find((config) => config?.businessArea === "ALL");

          if (!applicableFeeConfig)
            throw new Error("Failed to fetch fee configuration");

          const { minimumRegistrationPercentage, minimumAdmissionPercentage } =
            applicableFeeConfig;
          setFeeConfiguration({
            minimumRegistrationPercentage,
            minimumAdmissionPercentage,
          });
        }
      } catch (err) {
        setError(err.message || "An error occurred");
        setFeeConfiguration({});
      } finally {
        setLoading(false);
      }
    };

    if (academicCareer && studentBusinessArea) fetchData();
  }, [academicCareer, studentBusinessArea]);

  return { feeConfiguration, error, loading };
};

export const useFetchContactDetails = (
  studentApplicationId,
  opportunityOwnerId,
) => {
  const [isFetching, setIsFetching] = useState(false);
  const [contactDetails, setContactDetails] = useState({
    isMobileNumber: false,
    mobile: "",
  });

  useEffect(() => {
    const fetchContactDetails = async () => {
      setIsFetching(true);
      const response = await getStudentDetails(
        studentApplicationId,
        opportunityOwnerId,
      );
      try {
        if (response && response?.code === 200) {
          setIsFetching(false);
          const { preferredMobileNumber, preferredEmailId } =
            response?.data?.studentApplicationDetailsSearchResponseDTOList[0];
          setContactDetails({
            mobile: preferredMobileNumber,
            email: preferredEmailId,
            isMobileNumber: preferredMobileNumber ? true : false,
          });
          setIsFetching(false);
        }
      } catch (error) {
        setIsFetching(false);
      }
    };
    if (studentApplicationId) fetchContactDetails(studentApplicationId);
  }, [studentApplicationId]);

  return { isFetching, contactDetails };
};

export const useZeroPaidAmountCase = (
  selectedCharges,
  balanceAmount,
  setPaymentMode,
  collectedPayment,
) => {
  useEffect(() => {
    if (balanceAmount === 0) {
      const selectedChargesList = getSelectedItemList(selectedCharges);
      const totalItemNetBal = getNetItemsBalance(selectedChargesList);

      console.log(selectedChargesList, "selectedChargesList");

      if (
        selectedChargesList.length > 0 &&
        collectedPayment.length === 0 &&
        totalItemNetBal === 0
      ) {
        setPaymentMode((currentCollectedPaymentList) => [
          ...currentCollectedPaymentList,
          {
            paidAmount: 0,
            paymentMode: "CASH",
            paymentModeId: "9",
            isAutoCash: true,
          },
        ]);
      }
    }
  }, [balanceAmount, selectedCharges, setPaymentMode, collectedPayment]);
};
